import { Component, OnInit } from '@angular/core';
import { DepartmentFilter, HomeService } from '../../home.service';

interface RankingDepartmentFilter extends DepartmentFilter {
    id_depto;
}
@Component({
    selector: 'app-featured-rankings',
    templateUrl: './featured-rankings.component.html',
    styleUrls: ['./featured-rankings.component.scss'],
})
export class FeaturedRankingsComponent implements OnInit {
    list: any;
    /**
     * Opções de filtro por deparatmento
     */
    departmentFilters: RankingDepartmentFilter[];
    selectedDepartment: string;

    constructor(private homeService: HomeService) {}

    ngOnInit(): void {
        this.getRankings();
    }

    getRankings(departmentType?: string) {
        this.homeService.getFeaturedRankings(departmentType).subscribe((response) => {
            this.list = response.registers.list;
            this.departmentFilters = response.registers.filter;
            this.selectedDepartment = this.departmentFilters?.find(
                (deparmentFilter) => deparmentFilter.selected
            )?.id_depto;
        });
    }

    onDepartmentChange(departmentType) {
        this.getRankings(departmentType);
    }
}
